import { replaceUnderscores } from "~/common/utils";
import { CompletedRadioAnswer } from "~/common/utils/consultations/shared";

export const formatRadioAnswers = (answer: CompletedRadioAnswer[]) =>
  answer.map((val) => (val.value ? replaceUnderscores(val.value) : ""));
